require("./utils.js");
module.exports = function () {
  this.locale = "en";
  this.defaultLocale = "en";
  this.supported = ["en", "es", "de", "kr", "pr"];
  this.translations = {};
  this.parseText = function (f) {
    var g = [];
    f.split("\n")
      .filter((h) => h)
      .forEach((h) => {
        var j = h.split(" ");
        g[j[0]] = j.slice(1).join(" ");
      });
    return g;
  };
  for (var d = 0; d < this.supported.length; d++) {
    this.translations[this.supported[d]] = this.parseText(
      require("../i18n/init.js")("./" + this.supported[d] + ".js"),
    );
  }
  this.saveLocale = function () {
    localStorage.setItem("krk_lang", this.locale || this.defaultLocale);
  };
  this.setLocale = function (f) {
    if (this.supported.indexOf(f) > -1) {
      this.locale = f;
    }
    this.saveLocale();
  };
  this.setLocaleFromStorage = function () {
    if (typeof Storage != "undefined") {
      this.setLocale(localStorage.getItem("krk_lang"));
    }
  };
  this.setLocaleFromStorage();
  this.encode = function (f) {
    var g = [];
    for (var h = f.length - 1; h >= 0; h--) {
      g.unshift(["&#", f[h].charCodeAt(), ";"].join(""));
    }
    return g.join("");
  };
  this.get = function (f) {
    let g =
      this.translations[this.locale][f] ||
      this.translations[this.defaultLocale][f] ||
      "UNLOCALIZED STRING";
    for (var h = 1; h < arguments.length; h++) {
      g = g.replace("{" + (h - 1) + "}", arguments[h]);
    }
    return g;
  };
  this.t = this.get;
};
